/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mock_Compliant_InvoiceInputs */

const en_mock_compliant_invoice = /** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticated Receipt`)
};

const es_mock_compliant_invoice = /** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibo Autenticado`)
};

const fr_mock_compliant_invoice = /** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reçu authentifié`)
};

const de_mock_compliant_invoice = /** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierte Quittung`)
};

const id_mock_compliant_invoice = /** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanda Terima Terautentikasi`)
};

/** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */
const ja_mock_compliant_invoice = en_mock_compliant_invoice;

/** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */
const zh_mock_compliant_invoice = en_mock_compliant_invoice;

/** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */
const ar_mock_compliant_invoice = en_mock_compliant_invoice;

/** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */
const it_mock_compliant_invoice = en_mock_compliant_invoice;

/** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */
const ru_mock_compliant_invoice = en_mock_compliant_invoice;

/** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */
const pt_mock_compliant_invoice = en_mock_compliant_invoice;

/** @type {(inputs: Mock_Compliant_InvoiceInputs) => LocalizedString} */
const ko_mock_compliant_invoice = en_mock_compliant_invoice;

/**
* | output |
* | --- |
* | "Authenticated Receipt" |
*
* @param {Mock_Compliant_InvoiceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const mock_compliant_invoice = /** @type {((inputs?: Mock_Compliant_InvoiceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mock_Compliant_InvoiceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mock_compliant_invoice(inputs)
	if (locale === "es") return es_mock_compliant_invoice(inputs)
	if (locale === "fr") return fr_mock_compliant_invoice(inputs)
	if (locale === "de") return de_mock_compliant_invoice(inputs)
	if (locale === "ja") return ja_mock_compliant_invoice(inputs)
	if (locale === "zh") return zh_mock_compliant_invoice(inputs)
	if (locale === "ar") return ar_mock_compliant_invoice(inputs)
	if (locale === "id") return id_mock_compliant_invoice(inputs)
	if (locale === "it") return it_mock_compliant_invoice(inputs)
	if (locale === "ru") return ru_mock_compliant_invoice(inputs)
	if (locale === "pt") return pt_mock_compliant_invoice(inputs)
	return ko_mock_compliant_invoice(inputs)
});